import {uploadFile} from "@/services/networkService.js";

export async function UploadFile(context, file) {
    let response = await uploadFile(`upload/${context.appId}/${context.panelId}`, file, context);

    if (response.ok) {
        let model = await response.json();

        return {
            url: model.url
        };
    } else {
        throw new Error('Failed to upload file');
    }
}